import React, { useState } from "react";
import "./SearchFilter.css";
import {
  DropDownList,
  AutoComplete,
  DropDownListFilterChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { Form, Button, InputGroup, Collapse } from "react-bootstrap";
import { GetApplicantName } from "../../apis/OrderAPI";
import * as BsIcons from "react-icons/bs";

export const ReportFilter = ({
  search,
  reportTypes,
  requestorid,
  investigatorid,
  advSearch,
  reportFilterChange,
  searchPlaceHolder,
  displayShort,
  shortFields,
  sortOrder,
}) => {
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [applicantNames, setApplicantNames] = useState([]);
  const [applicantName, setApplicantName] = useState("");
  const [completionStartDate, setCompletionStartDate] = useState("");
  const [completionEndDate, setCompletionEndDate] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [activeElems, setActiveElems] = useState([]);

  const defaultReportType = {
    report_id: "0",
    report_name: "Choose Report....",
  };
  const [reportType, setReportType] = useState(defaultReportType);

  const defaultSort = {
    value: "",
    text: "Order By",
  };

  const [sortBy, setSortBy] = useState(defaultSort);

  const getApplicantNames = async (e) => {
    let searchName = e.value;
    setApplicantName(searchName);
    if (searchName === "" && activeElems.length > 0)
      removeItem("applicantName");
    if (searchName.length > 2) {
      var result = await GetApplicantName({
        searchName,
        requestorid,
        investigatorid,
      });
      setApplicantNames(result.data);
    }
    if (activeElems.length > 0) setIsActive(true);
    else setIsActive(false);
  };

  const clearFilter = () => {
    setCompletionStartDate("");
    setCompletionEndDate("");
    setApplicantName("");
    setReportType(defaultReportType);
    setIsActive(false);
    setActiveElems([]);
  };

  const handleSearch = (e) => {
    if (searchPlaceHolder.includes("id")) {
      const re = /^[0-9\b]+$/;
      if (e === "" || re.test(e)) {
        setSearchValue(e);
      }
    } else setSearchValue(e);
  };

  const handleCompletionStartDate = (e) => {
    let rstdt = e.target.value;
    if (rstdt !== "") {
      var stdt = new Date(e.target.value);
      if (completionEndDate != null && completionEndDate !== "") {
        var endt = new Date(completionEndDate);
        if (stdt > endt) setCompletionEndDate(rstdt);
        setCompletionStartDate(rstdt);
        activeElems.push("completionDate");
        setIsActive(true);
      } else {
        if (activeElems.length > 0) removeItem("completionDate");
        setCompletionStartDate(rstdt);
      }
    } else {
      if (activeElems.length > 0) removeItem("completionDate");
      setCompletionStartDate(rstdt);
    }
  };

  const handleCompletionEndDate = (e) => {
    let rendt = e.target.value;
    if (rendt !== "") {
      var endt = new Date(e.target.value);
      if (completionStartDate != null && completionStartDate !== "") {
        var stdt = new Date(completionStartDate);
        if (endt < stdt) setCompletionStartDate(rendt);
        setCompletionEndDate(rendt);
        activeElems.push("completionDate");
        setIsActive(true);
      } else {
        if (activeElems.length > 0) removeItem("completionDate");
        setCompletionEndDate(rendt);
      }
    } else {
      if (activeElems.length > 0) removeItem("completionDate");
      setCompletionEndDate(rendt);
    }
  };

  const handleReportType = (e) => {
    console.log(e.value.report_id);
    if (e.value.report_id == 0 && activeElems.length > 0)
      removeItem("reportType");
    else {
      setIsActive(true);
      activeElems.push("reportType");
    }

    setReportType(e.value);
    //console.log(activeCount);
    if (activeElems.length > 0) setIsActive(true);
    else setIsActive(false);
  }

  function removeItem(item) {
    let indx = activeElems.indexOf(item);
    if (indx != -1) setActiveElems(activeElems.splice(indx, 1));
  }

  return (
    <>
      <div className="filters-option">
        <div className="search-by-filter">
          <InputGroup>
            <Form.Control
              placeholder={searchPlaceHolder}
              aria-label="Search by"
              aria-describedby="Search-by"
              value={searchValue}
              onChange={(e) => handleSearch(e.target.value)}
            />
            <Button
              className="search-btn"
              type="button"
              id="Search-by"
              onClick={() => {
                clearFilter();
                search(searchValue);
              }}
            >
              <i className="fa-solid fa-magnifying-glass"></i>
            </Button>
          </InputGroup>
        </div>
        <div
          className={advSearch == null ? "no-display" : "multi-options-filter"}
        >
          <button
            className="btn btn-options-filter"
            onClick={() => setOpen(!open)}
            aria-expanded={open}
            aria-controls="example-collapse-text"
          >
            <i className="fa-solid fa-filter"></i>
          </button>
          <Collapse className="filter-box" in={open}>
            <div className="filter-box-inner" id="example-collapse-text">
              <Button
                className="filter-box-close"
                onClick={() => setOpen(!open)}
              >
                <BsIcons.BsXLg />
              </Button>
              <Form className="filter-box-form">
                <Form.Group className="mb-4 row" controlId="CompletionDates">
                  <Form.Label className="col-lg-4 col-md-6 col-sm-12">
                    Completion Dates:
                  </Form.Label>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <Form.Control
                      type="date"
                      placeholder="From"
                      value={completionStartDate}
                      onChange={handleCompletionStartDate}
                    />
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <Form.Control
                      type="date"
                      placeholder="To"
                      value={completionEndDate}
                      onChange={handleCompletionEndDate}
                    />
                  </div>
                </Form.Group>
                <Form.Group className="mb-4 row" controlId="ApplicantName">
                  <Form.Label className="col-lg-4 col-md-6 col-sm-12">
                    Applicant Name:
                  </Form.Label>
                  <div className="col-lg-8 col-md-6 col-sm-12">
                    <AutoComplete
                      className="custom-form-control"
                      data={applicantNames}
                      placeholder="e.g. Adam"
                      value={applicantName}
                      onChange={getApplicantNames}
                    />
                  </div>
                </Form.Group>
                <Form.Group className="mb-4 row" controlId="OrderStatus">
                  <Form.Label className="col-lg-4 col-md-6 col-sm-12">
                    Report Type:
                  </Form.Label>
                  <div className="col-lg-8 col-md-6 col-sm-12">
                    <DropDownList
                      className="custom-form-control-select"
                      data={reportTypes}
                      textField="report_name"
                      dataItemKey="report_id"
                      defaultItem={defaultReportType}
                      value={reportType}
                      onChange={handleReportType}
                      filterable={true}
                      onFilterChange={reportFilterChange}
                    />
                  </div>
                </Form.Group>
                <div className="row">
                  <div className="col-lg-4 col-md-4 col-sm-12"></div>
                  <div className="col-lg-8 col-md-8 col-sm-12">
                    <Button
                      variant="primary"
                      disabled={!isActive}
                      className={
                        isActive
                          ? "filter-apply-btn"
                          : "filter-apply-btn-inactive"
                      }
                      type="button"
                      onClick={() => {
                        setSearchValue("");
                        advSearch({
                          completionStartDate,
                          completionEndDate,
                          applicantName,
                          reportType,
                        });
                        setOpen(!open);
                        clearFilter();
                      }}
                    >
                      Apply
                    </Button>
                    <Button
                      className="filter-close-btn"
                      onClick={() => {
                        clearFilter();
                        setOpen(!open);
                      }}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </Form>
            </div>
          </Collapse>
        </div>
        <div className={displayShort ? "short-by-filter" : "no-display"}>
          <DropDownList
            className="custom-form-control-select sortby-filter"
            data={shortFields}
            textField="text"
            dataItemKey="value"
            defaultItem={defaultSort}
            value={sortBy}
            onChange={(e) => {
              setSortBy(e.target.value);
              sortOrder(e.target.value);
            }}
          />
        </div>
      </div>
    </>
  );
};
